import { MAP_TOOL, LAYER_IDS } from '@tmapy/config';
import { actionSetLayerFeatures, getFeaturesFromLayer } from '@tmapy/mapcore';
import { getLineStringsFromGeoJSONGeometry } from '../utils/getLineStringsFromGeoJSONGeometry';
import { getIntersectionCoord } from '../utils/getIntersectionCoord';
import { modifyMultiLineString } from '../utils/modifyLineString';
import { actionUpdateJoinLineTool } from './components';
export const actionCreateIntersectionPoint = (payload, coordinate) => async (dispatch, getState) => {
    if (payload.layerId !== LAYER_IDS.EDIT_TOOLS_HIGHLIGHT) {
        return;
    }
    const state = getState();
    const intersectionInteraction = state.editTools.intersectionInteraction;
    if (!coordinate) {
        return;
    }
    const layers = state.mapCore.layers;
    const highlightFeatures = getFeaturesFromLayer(layers, LAYER_IDS.EDIT_TOOLS_HIGHLIGHT);
    const editFeature = highlightFeatures?.length === 2
        ? highlightFeatures[1]
        : getFeaturesFromLayer(layers, LAYER_IDS.EDIT_TOOLS_MODIFY)?.[0];
    const highlightFeature = highlightFeatures?.[0];
    if (!editFeature || !highlightFeature) {
        return;
    }
    const editLineStrings = getLineStringsFromGeoJSONGeometry(editFeature.geometry);
    const highlightLineStrings = getLineStringsFromGeoJSONGeometry(highlightFeature.geometry);
    const intersectionCoord = getIntersectionCoord(intersectionInteraction, coordinate, editLineStrings, highlightLineStrings);
    if (intersectionCoord) {
        const point = {
            geometry: {
                type: 'Point',
                coordinates: intersectionCoord,
            },
            properties: {},
            type: 'Feature',
        };
        dispatch(actionSetLayerFeatures(LAYER_IDS.EDIT_TOOLS_SNAP, [point]));
        if (state.uiManager.activeMapTool !== MAP_TOOL.INTERSECTION_SPLIT_LINE) {
            const editGeometry = editFeature.geometry;
            const highlightGeometry = highlightFeature.geometry;
            if (editGeometry.type !== 'MultiLineString' ||
                highlightGeometry.type !== 'MultiLineString') {
                console.warn('[actionCreateIntersectionPoint] Unsupported types', editGeometry, highlightGeometry);
                return;
            }
            const editedGeometry = modifyMultiLineString(editGeometry.coordinates, intersectionCoord, null);
            const highlightedGeometry = modifyMultiLineString(highlightGeometry.coordinates, intersectionCoord, coordinate);
            const line1 = {
                geometry: {
                    type: 'MultiLineString',
                    coordinates: highlightedGeometry,
                },
                properties: {},
                type: 'Feature',
            };
            const line2 = {
                geometry: {
                    type: 'MultiLineString',
                    coordinates: editedGeometry,
                },
                properties: {},
                type: 'Feature',
            };
            dispatch(actionSetLayerFeatures(LAYER_IDS.EDIT_TOOLS_SNAP, [line1, line2]));
            const payload = { joinFeatures: [line1, line2], editFeature, highlightFeature };
            dispatch(actionUpdateJoinLineTool(payload));
        }
    }
};
//# sourceMappingURL=createIntersectionPoint.js.map